import { render, staticRenderFns } from "./scanrecord.vue?vue&type=template&id=4152b2f2&scoped=true&"
import script from "./scanrecord.vue?vue&type=script&lang=js&"
export * from "./scanrecord.vue?vue&type=script&lang=js&"
import style0 from "./scanrecord.vue?vue&type=style&index=0&id=4152b2f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4152b2f2",
  null
  
)

export default component.exports